if(typeof window.PDFLib === 'undefined') { var e = new Error("Cannot find module 'window.PDFLib'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = window.PDFLib;